// with exclamation mark before raw-loader we override default loader for JSON to get content of the file instead of url
import initialTranslationsRaw from '!raw-loader!./en-GB.json';

// types
import { IModule } from '@sitegen/common/types';

const getTranslation = (languageCode: string): Promise<string> =>
    import(/* webpackChunkName: "giveaway-[request]" */ `./${languageCode}.json`).then(
        (translationsModule: IModule): string => translationsModule.default
    );

const initialTranslations = JSON.parse(initialTranslationsRaw);

export { initialTranslations, getTranslation };
